import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tva-report" };
const _hoisted_2 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "row g-4" };
const _hoisted_5 = { class: "col-lg-8" };
const _hoisted_6 = { class: "card border-0 shadow-sm p-20 h-100" };
const _hoisted_7 = { class: "d-flex justify-content-between align-items-center mb-20" };
const _hoisted_8 = { class: "table-responsive" };
const _hoisted_9 = { class: "table table-hover align-middle" };
const _hoisted_10 = { class: "fw-bold" };
const _hoisted_11 = { class: "text-end" };
const _hoisted_12 = { class: "text-end" };
const _hoisted_13 = { class: "text-end text-success fw-medium" };
const _hoisted_14 = { class: "text-end fw-black" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = {
    key: 0,
    class: "border-top-2"
};
const _hoisted_17 = { class: "fw-bold" };
const _hoisted_18 = { class: "text-end" };
const _hoisted_19 = { class: "text-end" };
const _hoisted_20 = { class: "text-end text-success" };
const _hoisted_21 = { class: "text-end text-primary" };
const _hoisted_22 = { class: "col-lg-4" };
const _hoisted_23 = { class: "card border-0 shadow-sm p-20 h-100" };
const _hoisted_24 = {
    key: 1,
    class: "d-flex align-items-center justify-content-center text-muted small",
    style: { "height": "280px" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                    }, null, -1),
                    _createElementVNode("p", { class: "text-muted mt-2" }, "Calcul du rapport TVA...", -1)
                ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "fw-bold mb-0 text-uppercase small text-muted" }, "Détail par Taux", -1)),
                                _createElementVNode("button", {
                                    class: "btn btn-sm btn-outline-dark",
                                    onClick: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.printReport && _ctx.printReport(...args)))
                                }, [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("i", { class: "ph-bold ph-printer me-1" }, null, -1),
                                        _createTextVNode(" Imprimer ", -1)
                                    ]))])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("table", _hoisted_9, [
                                    _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "bg-light" }, [
                                        _createElementVNode("tr", { class: "small text-muted" }, [
                                            _createElementVNode("th", null, "Taux (%)"),
                                            _createElementVNode("th", { class: "text-end" }, "Commandes"),
                                            _createElementVNode("th", { class: "text-end" }, "CA HT (Net)"),
                                            _createElementVNode("th", { class: "text-end" }, "TVA"),
                                            _createElementVNode("th", { class: "text-end" }, "CA TTC (Brut)")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: item.rate
                                            }, [
                                                _createElementVNode("td", _hoisted_10, _toDisplayString(item.rate), 1),
                                                _createElementVNode("td", _hoisted_11, _toDisplayString(item.count), 1),
                                                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.formatCHF(item.net)), 1),
                                                _createElementVNode("td", _hoisted_13, "+" + _toDisplayString(_ctx.formatCHF(item.tax)), 1),
                                                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.formatCHF(item.gross)), 1)
                                            ]));
                                        }), 128)),
                                        (_ctx.reportData.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[4] || (_cache[4] = [
                                                    _createElementVNode("td", {
                                                        colspan: "5",
                                                        class: "text-center py-4 text-muted small"
                                                    }, "Aucune donnée sur cette période", -1)
                                                ]))]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.reportData.length > 0)
                                        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_16, [
                                            _createElementVNode("tr", _hoisted_17, [
                                                _cache[5] || (_cache[5] = _createElementVNode("td", null, "TOTAL", -1)),
                                                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.totalCount), 1),
                                                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.formatCHF(_ctx.totalNet)), 1),
                                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatCHF(_ctx.totalTax)), 1),
                                                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.formatCHF(_ctx.totalGross)), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _cache[7] || (_cache[7] = _createElementVNode("h6", { class: "fw-bold mb-20 text-uppercase small text-muted" }, "Répartition TVA", -1)),
                            (_ctx.reportData.length > 0)
                                ? (_openBlock(), _createBlock(_component_apexchart, {
                                    key: 0,
                                    type: "donut",
                                    height: "280",
                                    options: _ctx.chartOptions,
                                    series: _ctx.chartSeries
                                }, null, 8, ["options", "series"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_24, " Pas assez de données ")),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-20 p-15 bg-light rounded" }, [
                                _createElementVNode("p", { class: "small text-muted mb-0" }, "Note : Les calculs sont basés sur le montant total de chaque commande et le prorata de TVA appliqué.")
                            ], -1))
                        ])
                    ])
                ])
            ]))
    ]));
}
